import apiClient from "../utils/apiClient";
import { apiUtils } from "../utils/commonUtils";

export const fetchDashboardData = async () => {
  try {
    const response = await apiClient.get('/dashboard-data');

    if (response.status >= 200 && response.status < 300) {
      const raw = response.data?.data || {};
      return {
        success: true,
        data: raw,
        message: response.data?.message || 'Dashboard data fetched successfully'
      };
    }

    throw new Error(response.data?.message || 'Failed to fetch dashboard data');
  } catch (error) {
    return apiUtils.handleError(error, 'Failed to fetch dashboard data');
  }
};

export const fetchExpiringSoonTenants = async (params = {}) => {
  try {
    const { page = 1, per_page = 5 } = params;
    const response = await apiClient.get('/dashboard-data-expiringSoon', {
      params: { page, per_page }
    });

    if (response.status >= 200 && response.status < 300) {
      const data = response.data?.data || [];
      const meta = response.data?.meta || {};
      return {
        success: true,
        data,
        meta,
        message: response.data?.message || 'Expiring tenants fetched successfully'
      };
    }

    throw new Error(response.data?.message || 'Failed to fetch expiring tenants');
  } catch (error) {
    return apiUtils.handleError(error, 'Failed to fetch expiring tenants');
  }
};

